module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/046-micronesia-ed166ed1efb9a792c358ca768717245e.svg";